import { addQueryArgs } from '@wordpress/url';
import { getParamsOfUrl, getUrl } from '../mixins/search';
import { getWishListCookie } from './toggle-wishlist';
import { setCookie } from '../../mixins/cookie';

const wishlistNode = document.querySelector( '#realpress-wishlist' );
const wishListTitleNode = wishlistNode.querySelector( '.realpress-wishlist-title' );
const containerNode = wishlistNode.querySelector( '.realpress-property-container' );

const messagePopup = document.querySelector( '#realpress-snackbar' );
const { __ } = wp.i18n;
let popupTimeout;

//Loadmore
const loadMoreWrapperNode = wishlistNode.querySelector( '.realpresss-load-more' );
let loadmoreBtnNode, loadingNode;

//infinite scroll
const infiniteScrollNode = wishlistNode.querySelector( '.realpresss-infinite-scroll' );
let infiniteLoadingNode;
//-----------
const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
const paginationType = REALPRESS_GLOBAL_OBJECT.pagination_type || '';
const defaultQuery = { orderby: 'name', order: 'asc' };
let query = {};
let isFetching = false;
let nextPage = null;
const userId = REALPRESS_GLOBAL_OBJECT.user_id || '';

const realpressListProperty = () => {
	if ( ! containerNode ) {
		return;
	}
	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}

	if ( ! userId ) {
		const propertyIds = getWishListCookie();
		query = { ...query, post_in: propertyIds };
	}

	//Loadmore
	if ( loadMoreWrapperNode ) {
		loadmoreBtnNode = loadMoreWrapperNode.querySelector( '.realpress-load-more-btn' );
		loadingNode = loadMoreWrapperNode.querySelector( '.realpress-loading-display' );
	}

	//Infinite Scroll
	if ( infiniteScrollNode ) {
		infiniteLoadingNode = infiniteScrollNode.querySelector( '.realpress-loading-display' );
	}

	getProperties( query );
	pagination();
	removeWishList();
};

const getProperties = ( queryParam = {}, isLoadmore = false ) => {
	if ( isLoadmore === false ) {
		containerNode.style.opacity = 0.4;
	}
	let param = { ...defaultQuery, ...queryParam };

	if ( containerNode.getAttribute( 'data-loop-item-id' ) ) {
		param = { ...param, 'loop-item-id': containerNode.getAttribute( 'data-loop-item-id' ) };
	}

	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/wishlist', param ), method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			if ( isLoadmore ) {
				containerNode.insertAdjacentHTML( 'beforeend', res.data.content );
			} else {
				containerNode.innerHTML = res.data.content;
			}
		} else {
			if ( loadMoreWrapperNode ) {
				loadMoreWrapperNode.style.display = 'none';
			}
			if ( res.msg && isLoadmore === false ) {
				containerNode.innerHTML = `<p>${ res.msg }</p>`;
			}
		}
		renderPagination( res );
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		//Fix error in pagination 2

		// const params = query;
		// if ( ! userId ) {
		// 	delete params.post_in;
		// }

		if ( isLoadmore === false ) {
			const urlPush = getUrl( query );
			window.history.pushState( '', '', urlPush );
		}
		containerNode.style.opacity = 1;
	} );
};

const renderPagination = ( res ) => {
	if ( paginationType === 'standard' ) {
		if ( res.data.pagination !== undefined ) {
			wishlistNode.querySelector( '.realpress-pagination' ).innerHTML = res.data.pagination;
		} else {
			wishlistNode.querySelector( '.realpress-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			wishlistNode.querySelector( '.realpress-from-to' ).innerHTML = res.data.from_to;
		} else {
			wishlistNode.querySelector( '.realpress-from-to' ).innerHTML = '';
		}
	}

	if ( paginationType === 'loadmore' ) {
		if ( res.data.pagination === undefined ) {
			nextPage = null;
			return;
		}

		loadmoreBtnNode.innerHTML = res.data.pagination;
		loadingNode.style.display = 'none';
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}

	if ( paginationType === 'infinite_scroll' ) {
		infiniteLoadingNode.style.display = 'none';
		isFetching = false;
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}
};

const pagination = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const item = target.closest( 'a' );
		if ( paginationType === 'standard' ) {
			if ( ! item ) {
				return;
			}

			if ( ! item.getAttribute( 'data-page' ) ) {
				return;
			}

			const paginationNode = target.closest( '.realpress-pagination' );
			if ( ! paginationNode ) {
				return;
			}
			event.preventDefault();
			const page = item.getAttribute( 'data-page' );
			query = { ...query, page };
			getProperties( query );
			wishListTitleNode.scrollIntoView( { behavior: 'smooth' } );
		}

		if ( paginationType === 'loadmore' ) {
			if ( target.parentNode !== loadmoreBtnNode ) {
				return;
			}

			event.preventDefault();
			target.remove();
			loadingNode.style.display = 'block';
			query = { ...query, page: nextPage };
			getProperties( query, true );
		}
	} );

	if ( paginationType === 'infinite_scroll' ) {
		window.addEventListener( 'scroll', ( event ) => {
			getScrollData();
		} );
	}
};

const getScrollData = () => {
	const distance = infiniteScrollNode.getBoundingClientRect().top - window.innerHeight;

	if ( isFetching === false && distance < 0 && nextPage ) {
		isFetching = true;
		infiniteLoadingNode.style.display = 'block';
		query = { ...query, page: nextPage };
		getProperties( query, true );
	}
};

const removeWishList = () => {
	document.addEventListener( 'click', function( event ) {
		const wishListNodes = containerNode.querySelectorAll( '.realpress-property-wishlist' );

		if ( ! wishListNodes ) {
			return;
		}
		for ( let i = 0; i < wishListNodes.length; i++ ) {
			const wishListNode = wishListNodes[ i ];
			if ( wishListNode.contains( event.target ) ) {
				let propertyId = wishListNode.getAttribute( 'data-property-id' );
				propertyId = parseInt( propertyId );
				wishListNode.disabled = true;
				if ( userId ) {
					const data = { property_id: propertyId };
					wp.apiFetch( {
						path: '/' + restNamespace + '/wishlist', method: 'POST', data,
					} ).then( ( res ) => {
						if ( res.status === 'success' ) {
							wishListNode.classList.toggle( 'active' );
						}

						messagePopup.innerHTML = __( 'Property WishList removed', 'realpress' );
						displayMessagePopup();
						if ( Object( query, 'page' ) ) {
							delete query.page;
						}
						getProperties( query );
					} ).catch( ( err ) => {
						console.log( err );
					} ).finally( () => {
						wishListNode.disabled = false;
					} );
				} else {
					let propertyIds = getWishListCookie();
					if ( propertyIds && propertyIds.includes( propertyId ) ) {
						//Remove wishlist property
						propertyIds = propertyIds.filter( ( item ) => item !== propertyId );
						messagePopup.innerHTML = __( 'Property WishList removed', 'realpress' );
					}

					setCookie( 'realpress_wishlist_property', propertyIds.join( ',' ), 30 );

					displayMessagePopup();

					const query = {
						post_in: propertyIds,
					};

					getProperties( query );
				}
			}
		}
	} );
};

const displayMessagePopup = () => {
	messagePopup.classList.add( 'active' );

	if ( popupTimeout ) {
		clearTimeout( popupTimeout );
	}

	popupTimeout = setTimeout( () => {
		messagePopup.classList.remove( 'active' );
		messagePopup.innerHTML = '';
	}, '3000' );
};

export default realpressListProperty;
